import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn, inputVariants, type InputVariants } from '../../../utils';

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>,
    InputVariants {
  error?: string;
  label?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, size, hasError, hasIcon, type = 'text', error, label, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    const inputElement = (
      <input
        ref={ref}
        id={inputId}
        type={type}
        className={cn(inputVariants({ variant, size, hasError: hasError || !!error, hasIcon }), className)}
        aria-invalid={hasError || !!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...props}
      />
    );

    if (variant === 'inline') return inputElement;

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-text-secondary mb-1.5">
            {label}
          </label>
        )}
        {inputElement}
        {error && (
          <p id={`${inputId}-error`} className="mt-1.5 text-sm text-error-600">
            {error}
          </p>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';
